import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=10622e52&scoped=true"
var script = {}
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=10622e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10622e52",
  null
  
)

export default component.exports